import adminApi from '../../components/apis/adminApi';

export async function getRidePromotionsService() {
  return adminApi.get('/api/ride-promotions').then((res) => res.data);
}

export async function getRidePromotionService(id) {
  return adminApi.get(`/api/admin/ride-promotions/${id}`).then((res) => res.data);
}

export async function createRidePromotionService(values) {
  return adminApi.post('/api/admin/ride-promotions', values).then((res) => res.data);
}

export async function editRidePromotionService(id, values) {
  return adminApi.put(`/api/admin/ride-promotions/${id}`, values).then((res) => res.data);
}

export async function deleteRidePromotionService(id) {
  return adminApi.delete(`/api/admin/ride-promotions/${id}`).then((res) => res.data);
}
